import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStateSelector } from '../../store/selectors';
import { paths } from '../path';

export interface RequireRoleProps {
    roles: number[];
    children: React.ReactNode;
}

export const RequireRole = (props: RequireRoleProps) => {
    const summary = useStateSelector((state) => state.userSummary.summary);
    if (summary && !props.roles.includes(summary.roleId)) {
        return <Navigate to={paths.account.venueSelection} replace />;
    }
    return <>{props.children}</>;
};
